import { HsHypersceneEngineConstants } from '../../engine-new/constants/hyperscene-engine-constants.global';

export namespace HsGraphicConstants {
  export function getLogDepth(farPlane: number): number {
    return 2 / (Math.log(farPlane + 1) / Math.LN2);
  }

  export const LOG_DEPTH: number = getLogDepth(HsHypersceneEngineConstants.FAR_PLANE);

  export const FLOATS_IN_VEC2: number = 2;
  export const FLOATS_IN_VEC3: number = 3;

  export const FLOAT32_BYTES: number = 4;
  export const XY_POINT_BYTES: number = 8;
  export const XYZ_POINT_BYTES: number = 12;
}
